import * as React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { motion } from "framer-motion";

export default function FluidNavbar(props) {
  const [opened, setOpened] = React.useState(false);

  React.useEffect(() => {
    // window.addEventListener("scroll", handleScroll);
  }, []);

  // const handleScroll = () => {
  //   if (window.scrollY > 100) {
  //     document.getElementById("fluidId").classList.add("sticky");
  //   } else {
  //     document.getElementById("fluidId").classList.remove("sticky");
  //   }
  // };

  const variant = opened ? "opened" : "closed";

  const top = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: 45,
      translateY: 10,
    },
  };
  const center = {
    closed: {
      opacity: 1,
    },
    opened: {
      opacity: 0,
    },
  };
  const bottom = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: -45,
      translateY: -6,
    },
  };

  return (
    <>
      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        id="fluidId"
        className="fluidNavbar"
      >
        <Navbar.Brand as={motion.div} href="#home">
          {props.brand}
        </Navbar.Brand>
        <Navbar.Toggle onClick={() => setOpened(!opened)}>
          <div className="bars-cont">
            <motion.div
              className="bars"
              variants={top}
              animate={variant}
            ></motion.div>
            <motion.div
              className="bars"
              variants={center}
              animate={variant}
            ></motion.div>
            <motion.div
              className="bars"
              variants={bottom}
              animate={variant}
            ></motion.div>
          </div>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">{props.children}</Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}
